import React, { useState, useEffect } from "react";
import {
  Dialog,
  Typography,
  Button,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import {
  getAddToHomeScreenFlag,
  setAddToHomeScreenFlag,
} from "../utils/databaseConfig";

const AddToHomeScreenPrompt = () => {
  const [open, setOpen] = useState(false);
  const [deviceType, setDeviceType] = useState("");

  useEffect(() => {
    const checkConditions = async () => {
      const userAgent = navigator.userAgent || navigator.userAgentData;
      const isAndroid = /android/i.test(userAgent);
      const isIOS = /iphone|ipad|ipod/i.test(userAgent);

      const isAppInstalled = window.matchMedia(
        "(display-mode: standalone)"
      ).matches;

      const popupShown = await getAddToHomeScreenFlag();
      if ((isAndroid || isIOS) && !isAppInstalled && !popupShown) {
        setDeviceType(isAndroid ? "android" : "ios");
        setOpen(true);
      }
    };

    checkConditions();
  }, []);

  const handleClose = async () => {
    setOpen(false);
    await setAddToHomeScreenFlag(true);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "30px",
        },
      }}
    >
      <DialogTitle>
        {" "}
        <Typography variant="h6" className="typography_heading head">
          Add to Home Screen{" "}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          For a better experience, add this application to your home screen:
        </Typography>
        {deviceType === "ios" ? (
          <Typography variant="body1" sx={{ mt: 2 }}>
            - Tap the share icon (in Chrome on the address bar top right and in
            Safari in the bottom bar center).
            <br />- Select "Add to Home Screen."
            <br />- Go to your home screen, and the app will appear over there
            under the name "Zuno Staar"
          </Typography>
        ) : deviceType === "android" ? (
          <Typography variant="body1" sx={{ mt: 2 }}>
            - Tap the three dots on the top right corner of the browser.
            <br />- Select "Add to Home Screen."
            <br />- Go to your home screen, and the app will appear over there
            under the name "Zuno Staar"
          </Typography>
        ) : (
          <Typography variant="body2">
            This feature is available on Android and iOS devices only.
          </Typography>
        )}
        <Button variant="contained" onClick={handleClose} sx={{ mt: 2 }}>
          Got it!
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default AddToHomeScreenPrompt;
